const contentData = [
  {
    title: "TensorFlow and Libraries",
    link: "https://www.tensorflow.org/",
    description:
      "We used TensorFlow to build and train our model. We captured thousands of photos of more than 40 Gestures."
  },
  {
    title: "React.JS for Frontend",
    link: "https://reactjs.org/",
    description:
      "Reason of choosing ReactJS for the frontend is that it's efficient and fast."
  },
  {
    title: "Authentication",
    link: "https://auth0.com/",
    description:
      "Auth0 was used for Authentication, as it's highly secure, scalable and easy to work with. "
  },
  {
    title: "Learn More About Our App Here",
    link: "#",
    description:
      "Please use your authroization to read more about our work"
  }
];

export default contentData;
